module.exports = __webpack_public_path__ + "media/images/brands/marque-wella@2x-b6eca7d374f63106f00a990f2b09a73b.jpg";